import { BigqueryResourceType } from './model';
import { BigqueryDestinationTrackingActions } from './tracking';

export const REFRESH_ACTION_MAP: Record<BigqueryResourceType, string> = {
  [BigqueryResourceType.BUCKET]: BigqueryDestinationTrackingActions.BUCKET_REFRESH_LIST_CLICK,
  [BigqueryResourceType.DATASET]: BigqueryDestinationTrackingActions.DATASET_REFRESH_LIST_CLICK,
  [BigqueryResourceType.PROJECT]: BigqueryDestinationTrackingActions.PROJECT_REFRESH_LIST_CLICK
};

export const BIGQUERY_CLUSTER_REGION_MAPPING: { [key: string]: string } = {
  'asia': 'asia-southeast1',
  'in': 'asia-south1',
  'eu': 'EU',
  'us': 'US',
  'us2': 'US',
  'au': 'australia-southeast1',
  'classplus': 'asia-south1'
};
